import React, { FC } from 'react';
import { PageTitle } from '../../layout/core';
import { dealsDetailsBreadCrumbs } from './PartnerCommissionsDetailsPage';
import { GoBackBtn } from '../header/GoBackBtn';
import { AgencyCommissionsDetails } from './AgencyCommissionsDetails';
import { useParams } from 'react-router-dom';
import { AgencyCommissionsDetailsInformation } from './AgencyCommissionsDetailsInformation';


export const AgencyCommissionsDetailsPage: FC = () => {
	const { agencyId } = useParams();

	return (
		<>
			<PageTitle breadcrumbs={dealsDetailsBreadCrumbs}>{agencyId}</PageTitle>
			<div className="mb-5">
				<GoBackBtn path={'/agencies/commissions'} />
			</div>
			<AgencyCommissionsDetailsInformation/>
			<AgencyCommissionsDetails/>
		</>
	);
};